import styles from "./TrainModel.module.scss";
import { Dataset } from "../../../../types";
import { useTrainingTasks } from "./useTrainingTasks";
import { useValidationTasks } from "./useValidationTasks";
import { TrainModelButton } from "./TrainModelButton";
import { TrainingStatus } from "./TrainingStatus";
import { ValidationStatus } from "./ValidationStatus";
import { useCallback, useEffect } from "react";
import { usePreviousValue } from "../../../../hooks/usePreviousValue";
import { useNavigate } from "react-router-dom";

export const TrainModel = ({
  dataset,
  isTrainWorthy,
}: {
  dataset: Dataset;
  isTrainWorthy: boolean;
}) => {
  const navigate = useNavigate();

  const {
    task: trainingTask,
    handleCancelTaskClick: handleCancelTrainingClick,
    handleCompletedClick: handleCompletedTrainingClick,
  } = useTrainingTasks(dataset.id);

  const {
    task: validationTask,
    handleCancelTaskClick: handleCancelValidationClick,
    handleCompletedClick: handleCompletedValidationClick,
  } = useValidationTasks(dataset.id);

  const prevTrainingStatus = usePreviousValue(trainingTask?.status);
  const prevValidationStatus = usePreviousValue(validationTask?.status);

  const handleViewTrainingModelClick = useCallback(() => {
    navigate("/models-catalog");
  }, [navigate]);

  const handleViewValidationModelClick = useCallback(() => {
    navigate("/models-catalog?tab=validation_jobs");
  }, [navigate]);

  useEffect(() => {
    if (
      prevTrainingStatus &&
      prevTrainingStatus !== "COMPLETED" &&
      trainingTask?.status === "COMPLETED"
    ) {
      handleCompletedTrainingClick(handleViewTrainingModelClick);
    }
  }, [
    trainingTask?.status,
    prevTrainingStatus,
    handleCompletedTrainingClick,
    handleViewTrainingModelClick,
  ]);

  useEffect(() => {
    if (
      prevValidationStatus &&
      prevValidationStatus !== "COMPLETED" &&
      validationTask?.status === "COMPLETED"
    ) {
      handleCompletedValidationClick(handleViewValidationModelClick);
    }
  }, [
    validationTask?.status,
    prevValidationStatus,
    handleCompletedValidationClick,
    handleViewValidationModelClick,
  ]);

  const showTrainModelButton =
    (!trainingTask || !["INIT", "IN_PROGRESS"].includes(trainingTask.status)) &&
    (!validationTask ||
      !["INIT", "IN_PROGRESS"].includes(validationTask.status));

  return (
    <div className={styles.TrainModel}>
      {trainingTask && (
        <TrainingStatus
          task={trainingTask}
          handleCancelTaskClick={handleCancelTrainingClick}
          handleCompletedClick={() =>
            handleCompletedTrainingClick(handleViewTrainingModelClick)
          }
        />
      )}
      {validationTask && (
        <ValidationStatus
          task={validationTask}
          handleCancelTaskClick={handleCancelValidationClick}
          handleCompletedClick={() =>
            handleCompletedValidationClick(handleViewValidationModelClick)
          }
        />
      )}
      {showTrainModelButton && (
        <TrainModelButton isTrainWorthy={isTrainWorthy} dataset={dataset} />
      )}
    </div>
  );
};
